import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Type } from 'class-transformer';
import { ResourcesCssService } from '../../pages/resources/resources-css.service'

export class Filters {
  @Type(() => FilterSection)
  sections: FilterSection[]
  numResults: number
  orMode: boolean

  static defaults(): Filters {
    const model = new Filters()
    model.sections = []
    model.numResults = -1
    return model
  }

  // NOTE: We have 4 different kinds of matches: AND/OR between sections and AND/OR within a section. Currently
  // we are only doing AND between sections and AND within a section.
  filter(values: Array<any>, filterfn: (value: any, section: FilterSection, item: FilterItem) => boolean): Array<any>  {
    if (this.orMode) { // OR filter
      return values.filter( (value: any) => {
        let exclude = false  // by default, don't exclude anything
        this.sections.forEach( (section: FilterSection) => {
          const selectedItems = section.items.filter( (item: FilterItem) => item.selected )
          if (selectedItems.length > 0) {
            let include = false  // if items are selected, it must match at least one to be included
            selectedItems.forEach( (item: FilterItem) => {
              include = include || filterfn(value, section, item)
            })
            exclude = !include
          }
        })
        return !exclude
      })
    } else {  // AND filter -- a value must match all selected items in all sections
      return values.filter( (value: any) => {
        let include1 = true
        this.sections.forEach((section: FilterSection) => {
          const selectedItems = section.items.filter( (item: FilterItem) => item.selected )
          let include2 = true // if items are selected, it must match all to be included
          selectedItems.forEach((item: FilterItem) => {
            include2 = include2 && filterfn(value, section, item)
          })
          include1 = include1 && include2
        })
        return include1
      })
    }
  }

  selectedFilterItems(): FilterItem[] {
    const filterItems = []
    this.sections.forEach((section: FilterSection) => {
      section.items.forEach((item: FilterItem) => {
        if (item.selected) {
          filterItems.push(item)
        }
      })
    })
    return filterItems
  }

}

export class FilterSection {
  title: string
  @Type(() => FilterItem)
  items: FilterItem[]
  allowMultiple: boolean  // if multiple items can be selected in this section; null === false
}

export class FilterItem {
  title: string
  selected?: boolean  // undefined === false
  info?: any     // passed by caller to be used as caller sees fit
}

@Component({
  selector: 'app-resources-filter',
  templateUrl: './resources-filter.component.html',
  styleUrls: ['./resources-filter.component.scss'],
})
export class ResourcesFilterComponent implements OnInit {

  @Input() filters: Filters

  isExpanded = false

  constructor(public resourcesCssService: ResourcesCssService) { }

  ngOnInit() {
  }

  showList(): boolean {
    return this.resourcesCssService.responsiveClass() === '' || this.isExpanded
  }

  toggleExpanded() {
    if (this.resourcesCssService.responsiveClass() !== '') {
      this.isExpanded = !this.isExpanded
    }
  }

  itemClass(item: FilterItem): string {
    return item.selected ? 'selected' : ''
  }

  toggleFilter(section: FilterSection, item: FilterItem) {
    if (section.allowMultiple) {
      item.selected = !item.selected
    } else {
      section.items.forEach( (i: FilterItem) => i.selected = (i.title === item.title) ? !i.selected : false )
    }
  }

  clearFilters() {
    this.filters.sections.forEach( (section: FilterSection) => {
      section.items.forEach( (item: FilterItem) => {
        item.selected = false
      })
    })
  }

}
